<template>
    <nav class="navigation-main">
        <ul class="tag-list">
            <li class="tag"><router-link to="/performance" class="navigation-item tag-link" v-if="summaryView" :class="{ selected: summaryView.firstTag === activeTag }">{{ summaryView.firstTag }}</router-link></li>
            <li class="tag" v-for="vc in viewsByCategory.categories" :key="vc.name">
                <a class="navigation-item tag-link"  href @click.prevent="" :class="{ selected: vc.name === activeTag }">
                    <span>{{ vc.name }}</span>
                </a>
                <ul class="view-list">
                    <li v-for="v in vc.views" :key="v.id"><router-link :to="`/performance/${v.urlName}`" class="navigation-item" :class="{ selected: v.id === activeView }" @click="SET_CLICKED_VIEW_ID(v.id)">{{ v.name }}</router-link></li>
                </ul>
            </li>
        </ul>
        <feed-menu-control v-if="user && (user.company.hasFeature('Highlights') || user.internalUser)" />
    </nav>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import FeedMenuControl from './FeedMenuControl.vue'

    export default {
        name: 'NavigationPanel',
        components: {
            'feed-menu-control': FeedMenuControl
        },
        data() {
            return {
                activeView: null,
                activeTag: null
            }
        },
        watch: {
            'selectedContent': 'setActive'
        },
        computed: {
            ...mapGetters(['viewsByCategory', 'user', 'selectedContent', 'summaryView'])
        },
        async created() {
            await this.loadViews()
        },
        methods: {
            ...mapActions(['getViews']),
            ...mapMutations(['SET_CLICKED_VIEW_ID']),
            setActive() {
                this.activeTag = this.selectedContent.firstTag
                this.activeView = this.selectedContent.id
            },
            async loadViews() {
                const oktaToken = await this.$auth.getAccessToken()

                await this.getViews(oktaToken)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use 'sass:math';
    @import '../styles/base';
    @import '../../node_modules/hd-styles/base';
    @import '../../node_modules/hd-styles/modules/mixins';

    .navigation-main {
        display: flex;
        justify-content: space-between;
        background-color: $blue;
    }

    .tag-list {
        @include list-reset;
    }

    .tag-link {
        &:hover, &:focus {
            + .view-list {
                display: block;
            }
        }
    }

    .tag {
        position: relative;
        display: inline-block;
        margin-left: math.div($spacing-unit, 2);
    }

    .view-list {
        @include list-reset;
        background-color: $grey-dark;
        position: absolute;
        z-index: 1;
        white-space: nowrap;
        box-shadow: $grey-dark 0 2px 10px;
        display: none;

        &:hover {
            display: block;
        }

        li {
            border-bottom: solid $border-width-light $grey;

            &:last-child {
                border: none;
            }
        }

        a {
            background-color: $white;
            color: $grey-dark;

            &:hover, &:focus {
                background-color: $grey-light;
                outline: none;
            }

            &.selected {
                background-color: $grey-blue;
                color: $blue;
                font-weight: 500;
            }
        }
    }
</style>
